import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1686ca7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tabbed-kpi-cards"
};
const _hoisted_2 = {
  class: "kpi"
};
const _hoisted_3 = {
  class: "cards"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_evolution_split = _resolveComponent("evolution-split");
  const _component_kpi_card = _resolveComponent("kpi-card");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.kpi.value), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.kpi.scope, card => {
    return _openBlock(), _createBlock(_component_kpi_card, {
      key: card.key,
      type: card.type.value,
      value: card.value,
      component: $props.kpi.component,
      loading: $props.loading
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.splits, (split, index) => {
        return _openBlock(), _createBlock(_component_evolution_split, {
          class: _normalizeClass([{
            'has-border': index == 0 && split?.element?.value != 'Previous YTD'
          }]),
          key: split.key,
          split: split,
          loading: $props.loading
        }, null, 8, ["class", "split", "loading"]);
      }), 128))]),
      _: 2
    }, 1032, ["type", "value", "component", "loading"]);
  }), 128))])]);
}